import { FC, useEffect, useState } from "react";
import { useForm } from "../../../app/useForm";

import "./switch.css";

type SwitchProps = {
  name?: string;
  checked?: boolean;
  disable?: boolean;
};

export const Switch: FC<SwitchProps> = ({ name, checked, disable }) => {
  const [enabled, setEnabled] = useState(checked ?? false);
  const { handleFieldChange } = useForm();

  const handleChange = (value: boolean) => {
    setEnabled(value);
    handleFieldChange(name, value);
  };

  useEffect(() => {
    setEnabled(checked ?? false);
  }, [checked]);
  return (
    <input
      name={name ?? ""}
      id={name ?? ""}
      value={`${enabled}`}
      checked={enabled}
      disabled={disable}
      type="checkbox"
      className={`vviinn-switch justify-self-end ${
        enabled ? "text-stone-500" : "bg-stone-300 dark:bg-stone-600"
      } relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2 ${
        disable ? "cursor-not-allowed bg-stone-300! opacity-40" : ""
      } ${enabled ? "bg-stone-600!" : ""}`}
      onChange={(ev) => {
        handleChange(ev.target.checked);
      }}
    />
  );
};
